import { render, staticRenderFns } from "./cmpBindaddrDialog.vue?vue&type=template&id=08f51081&scoped=true&"
import script from "./cmpBindaddrDialog.vue?vue&type=script&lang=js&"
export * from "./cmpBindaddrDialog.vue?vue&type=script&lang=js&"
import style0 from "./cmpBindaddrDialog.vue?vue&type=style&index=0&id=08f51081&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f51081",
  null
  
)

export default component.exports